<template>
<div>
  <search-list
    @findData="findData">
  </search-list>
  <div class="page-wrapper">
  <table-list
      :columns="columns"
      :data="tableData"
      :total="total"
      :current="current"
      :loading="loading"
      @change-page="changePage"
    >
    </table-list>
    </div>
    <read-modal :n="readKey" :contractId="contractId"></read-modal>
    <update-modal :n="updateKey" :status ="status" :contractFid="contractId" @refresh="findData(searchData)"></update-modal>

</div>
</template>

<script type="text/ecmascript-6">
import { getProjects } from 'api/common'
import { getList } from 'api/renewalIntention'
import {formatDateTime} from "@/utils/format";
import SearchList from './components/SearchList'
import TableList from "components/TableList/index";
import ReadModal from "./components/ReadModal";
import UpdateModal from "./components/UpdateModal";

export default {
  name:'renewalintention',
  components:{
    SearchList,
    TableList,
    ReadModal,
    UpdateModal
  },
  data () {
    return {
      loading:false, // true
      total:0,
      current:1,
      readKey:0,
      updateKey:0,
      status:null,
      contractId:'',
      searchData:null,
      renewalIntention:[],
      columns:[
        {
        type:'index',
        width:60,
        align:'center'
        },
        {
          title:' ',
        },
        {
          title:'项目',
          key:'projectName',
          align:'center',
          width:160
        },
        {
          title:' ',
        },
        {
          title:'房间/床位号',
          key:'stockNumber',
          align:'center',
          width:120
        },
        {
          title:' ',
        },
        {
          title: '剩余天数',
          key: 'surplusDays',
          align: 'center',
          width:120
        },
        {
          title:' ',
        },
        {
          title: '续约意向',
          key: 'renewAgreementName',
          align: 'center',
          width:120,
          render:(h,params) => {
            return h('div',{
              'class':{
                'error-color': params.row.renewAgreement === 0,
                'success-color':params.row.renewAgreement === 3,
                'info-color':params.row.renewAgreement !== 0 && params.row.renewAgreement !== 3,
              } 
            },params.row.renewAgreementName)
          }
        },
        {
          title:' ',
        },
        {
          title: '租约类型',
          key: 'rentTypeName',
          align: 'center',
          width:100
        },
        {
          title:' ',
        },
        {
          title: '合同状态',
          key: 'contractStateName',
          align: 'center',
          width:100
        },
        {
          title:' ',
        },
        {
          title: '签约客户',
          key: 'customerName',
          align: 'center',
          width:220
        },
        {
          title:' ',
        },
        {
          title: '签约手机号',
          key: 'userPhone',
          align: 'center',
          width:120
        },
        {
          title:' ',
        },
        {
          title: '起租日',
          key: 'conStartDate',
          align: 'center',
          width:120,
          render: (h,params) => {
            return h('div',formatDateTime(params.row.conStartDate,false))
          }
        },
        {
          title:' ',
        },
        {
          title: '到期日',
          key: 'conEndDate',
          align: 'center',
          width:120,
          render: (h,params) => {
            return h('div',formatDateTime(params.row.conEndDate,false))
          }
        },
        {
          title:' ',
        },
        {
          title: '最近跟进时间',
          key: 'operationTime',
          align: 'center',
          width:180,
          render: (h,params) => {
            return h('div',formatDateTime(params.row.operationTime))
          }
          
        },
        {
          title:' ',
        },
        {
          title:'操作',
          key:'action',
          align:'center',
          fixed:'right',
          width:150,
          render: (h,params) =>{
            return h('div',[h('a',{
                style: {
                  marginRight: '5px',
                },
                on:{
                  click: () => {
                    this.contractId = params.row.fid
                    this.readKey++  
                  }
                }
              },'查看'),
              h('a',{
                style: {
                  marginRight: '5px',
                },
                on:{
                  click: () => {
                    this.contractId = params.row.fid
                    this.status = params.row.renewAgreement
                    this.updateKey++
                    
                  }
                }
              },'修改')
            ])
          }
        }
      ],
      tableData:[]
    };
 },
 methods:{
   changePage(n){
      this.loading  = true
      this.current = n;
      this.searchData.page = n
      this.getList(this.searchData)
    },
    getList(data){
      this.loading = true
      getList(data).then(res => {
        this.tableData = res.data.tContractVos
        this.total = res.data.total
        this.loading = false
      })
    },
   findData(data){
     this.current = 1;
     this.searchData = data
     this.searchData.page = 1
    //  console.log(this.searchData)
     this.getList(this.searchData)
   }
 }
}
</script>
